import { APP_NAME } from '@shared/constants'

export class PrivacyAgreementModalViewModel {
  static readonly title = `Welcome to ${APP_NAME}!`
  static readonly subtext = `Before you proceed, please read and agree to our policies:`
  static confirmBtnText = 'Continue'
  static cancelBtnText = 'Cancel'
  static nameFieldLabelText = 'Type Your Name'
  static dateFieldLabelText = `Today's Date`
  static readAndAcceptedStatement = `I have read and agree to the ${APP_NAME}`
  static termsAndConditionsLinkText = 'Subscription Terms and Conditions'
  static licenceAgreementLinkText = 'End User License Agreement'
  static privatePolicyLinkText = 'Privacy Policy'
}
